import { queryOptions, useQueryClient } from '@tanstack/react-query';
import { StudyStore } from 'app/interfaces/StudyStore';
import StudyStoreContext from 'app/providers/StudyStoreProvider/context';
import { useContext } from 'react';

export type GetStudyParams = {
  studyInstanceUID: string;
  studyID?: string;
};

type Dependencies = {
  studyStore: StudyStore;
};
export default function getStudyQueryOptions(params: GetStudyParams, dependencies?: Dependencies) {
  let studyStore = dependencies?.studyStore;
  try {
    // Allow it to be called outside of a React component just for queryKey generation
    studyStore ??= useContext(StudyStoreContext);
  } catch {}

  return queryOptions({
    queryKey: [{ query: '/study' }, params] as const,
    queryFn: async ({ queryKey }) => {
      const [, params] = queryKey;
      if ('studyID' in params) {
        const study = await studyStore.getStudy(params.studyID);
        if (study) return study;
      }
      return (
        (await studyStore.filterStudies({ studyInstanceUIDs: [params.studyInstanceUID] }))?.[0] ??
        null
      );
    },
  });
}
